import {
  GET_ALL_BILLS_ERROR,
  GET_ALL_BILLS_START,
  GET_ALL_BILLS_SUCCESS,
} from 'constants/action-types/settings/getAllBills';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ALL_BILLS_START:
      return {
        ...state,
        allBills: {
          loading: true,
          error: null,
          data: [],
          meta: {},
        },
      };
    case GET_ALL_BILLS_ERROR:
      return {
        ...state,
        allBills: {
          ...state.allBills,
          error: payload,
          loading: false,
        },
      };
    case GET_ALL_BILLS_SUCCESS:
      return {
        ...state,
        allBills: {
          ...state.allBills,
          data: payload.data,
          meta: payload.meta,
          loading: false,
        },
      };
    default:
      return null;
  }
};
